/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import { IMetadata, IMetadataComponent } from '../../store/types/MetadataTypes';
import { ILevelsLayout } from '../../store/types/StateTypes';

function getCrosstabUIComponent(metadataObj: IMetadata, levelsLayout: ILevelsLayout) {
    let res: IMetadataComponent | undefined;
    if (metadataObj.component) {
        res = metadataObj.component.components.find((comp) => (comp.componentType === 'crosstab'));
    }

    if (!res) {
        // TODO actual default component
        res = {
            componentType: 'crosstab',
            components: [],
            properties: {
                mergeCrosstabCells: true
            }
        }
    }

    return res;
}

export { getCrosstabUIComponent }
